import { useWebWoodContext } from 'context/WebWoodContext'
import { RefObject, useEffect, useRef, useState } from 'react'
import { IMediaItem } from 'types/media'
import Moveable from 'react-moveable'
import { ProcessingEvent } from '@renderforest/webwood-engine'

export const useLiveSizes = (
  item: IMediaItem,
  moveableRef: RefObject<Moveable | null>
) => {
  const { engine } = useWebWoodContext()
  const isResizingRef = useRef(false)

  const [liveSize, setLiveSize] = useState<{
    width: number
    height: number
  } | null>(null)

  useEffect(() => {
    setLiveSize(null)
  }, [item.width, item.height])

  useEffect(() => {
    if (liveSize) {
      moveableRef.current?.updateRect()
    }
  }, [liveSize, moveableRef])

  useEffect(() => {
    if (!engine) return
    const handler = ({
      id,
      width,
      height
    }: {
      id: string
      width: number
      height: number
    }) => {
      if (id !== item.id) return
      if (isResizingRef.current) return
      setLiveSize({ width, height })
    }
    engine.signals.on(ProcessingEvent.OBJECT_DISPLAY_SIZE_CHANGED, handler)
    return () => {
      engine.signals.off(ProcessingEvent.OBJECT_DISPLAY_SIZE_CHANGED, handler)
    }
  }, [engine, item.id])

  return { liveSize, isResizingRef }
}
